export enum TripTikClaimStatus {
    Active = 1,
    Closed = 2,
    Judicial = 3,
    BranchesFollowup = 4,
    Paid = 5,
    Stored = 6
}